import React from "react";
import "./index.scss";
import { headerConfig } from "./headerData";

const Header = () => {
  return (
    <header className="header-container">
      <img
        src={headerConfig.logo.src}
        alt={headerConfig.logo.alt}
        className="header-logo"
      />
    </header>
  );
};

export default Header;
